import React from 'react';
import styled from 'styled-components';
import { Skeleton as AntdSkeleton } from 'antd';
import { SkeletonButtonProps as AntdSkeletonButtonProps } from 'antd/lib/skeleton/Button';

export type SkeletonButtonProps = Omit<AntdSkeletonButtonProps, 'active'>;

export const SkeletonButton = styled(({ ...props }: SkeletonButtonProps) => <AntdSkeleton.Button {...props} active />)``;

export default SkeletonButton;
